import React from 'react'

import Tooltip2 from 'components/common/Tooltip2.0'
import { emitOpenQRCodeModal } from 'helpers/events'

import { Wrapper } from './styles'

export default function FilerUpload() {
    return (
        <Tooltip2
            content="upload note"
            placement="bottom"
            className="hover-here"
        >
            <Wrapper onClick={emitOpenQRCodeModal}>
                <img src="/assets/revamp/filer.svg" alt="filer-upload" />
            </Wrapper>
        </Tooltip2>
    )
}
